import React from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

export default function ListItemLink(props) {
  return (
    <div>
      {!!(props.val)?<ListItemButton sx={{p:0,m:0,pl:2}} component='a' href={props.val} target="_blank" rel="noreferrer"><ListItemText sx={{p:0,m:0,fontWeight:'bold'}} primary={props.label}/></ListItemButton>:null} 
    </div>
  )
}
